import { Checkout } from './Checkout';
import { SweetpassTicket } from './Ticket';

export const Sweetpass = {
  Checkout,
  Ticket: SweetpassTicket,
};
